var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import PremiumUtils from '../../../utils';
var basicSourceSettings = [
    {
        label: 'Default Sort Query',
        tooltip: 'This sort query is used if the data table column sorting is not set.',
        tableView: true,
        weight: 20,
        key: 'fetch.sort.defaultQuery',
        type: 'textfield',
        input: true
    },
    {
        label: 'Descending Order',
        tooltip: 'Type of default sorting.',
        tableView: false,
        defaultValue: false,
        weight: 30,
        key: 'fetch.sort.descending',
        customConditional: 'show = !!_.get(data, "fetch.sort.defaultQuery", "");',
        type: 'checkbox',
        input: true
    },
    {
        type: 'checkbox',
        input: true,
        weight: 40,
        key: 'allowCaching',
        label: 'Enable to Store Request Result in the Cache',
        defaultValue: true,
        tooltip: 'When checked, the requests and its results will be stored in the cache and if the Select will try to make the request to the same URL with the same paremetrs, the cached data will be returned. It allows to increase performance, but if the remote source\'s data is changing quite often and you always need to keep it up-to-date, uncheck this option.',
    },
];
export default [
    {
        type: 'checkbox',
        input: true,
        weight: 0,
        key: 'fetch.enableFetch',
        label: 'Enable fetch',
        defaultValue: false,
        tooltip: 'If fetch is enabled, the DataTable will be automatically populated with data from the data source and will not be submitted.',
    },
    {
        type: 'select',
        input: true,
        weight: 0,
        tooltip: 'The source to get the data. You can fetch from a URL or resource.',
        key: 'fetch.dataSrc',
        label: 'Fetch Source Type',
        dataSrc: 'values',
        validate: {
            required: true
        },
        customConditional: function (_a) {
            var data = _a.data, _ = _a._;
            return _.get(data, 'fetch.enableFetch', false);
        },
        customDefaultValue: function (_a) {
            var data = _a.data;
            if (data.fetch.url) {
                return 'url';
            }
            return;
        },
        data: {
            values: [
                {
                    value: 'url',
                    label: 'URL'
                },
                {
                    value: 'resource',
                    label: 'Resource'
                },
            ]
        },
    },
    {
        type: 'panel',
        title: 'Fetch Settings',
        key: 'fetchUrl',
        weight: 700,
        customConditional: function (_a) {
            var data = _a.data, _ = _a._;
            return _.get(data, 'fetch.dataSrc') === 'url';
        },
        components: __spreadArrays(PremiumUtils.baseEditFetchComponents([
            {
                key: 'dataSrc',
                ignore: true,
            },
            {
                key: 'indexeddb.fromExisting',
                ignore: true,
            },
            {
                key: 'indexeddb.database',
                ignore: true,
            },
            {
                key: 'indexeddb.table',
                ignore: true,
            },
            {
                key: 'indexeddb.database',
                ignore: true,
            },
            {
                key: 'indexeddb.table',
                ignore: true,
            },
            {
                key: 'fetch.url',
                conditional: '',
            },
            {
                key: 'fetch.method',
                ignore: true,
            },
            {
                key: 'fetch.headers',
                conditional: ''
            },
            {
                key: 'fetch.forwardHeaders',
                ignore: true,
            },
            {
                key: 'fetch.authenticate',
                conditional: ''
            },
            {
                key: 'specifyPostBodyPanel',
                ignore: true,
            },
            {
                key: 'allowCaching',
                ignore: true
            },
        ]), [
            {
                type: 'textfield',
                input: true,
                key: 'fetch.provider',
                weight: 10,
                label: 'Custom Fetch Provider',
                placeholder: 'Enter the name of your fetch provider (optional)',
                tooltip: 'A name of custom fetch provider. If not specified, default URL provider is used.',
                clearOnHide: true,
            }
        ], basicSourceSettings)
    },
    {
        type: 'panel',
        title: 'Fetch Settings',
        key: 'fetchResource',
        weight: 700,
        customConditional: function (_a) {
            var data = _a.data, _ = _a._;
            return _.get(data, 'fetch.dataSrc') === 'resource';
        },
        components: __spreadArrays([
            {
                type: 'select',
                input: true,
                dataSrc: 'url',
                data: {
                    url: '/form?type=resource&limit=1000000&select=_id,title',
                },
                authenticate: true,
                template: '<span>{{ item.title }}</span>',
                valueProperty: '_id',
                clearOnHide: true,
                label: 'Resource',
                key: 'fetch.resource',
                validate: {
                    required: true
                },
                lazyLoad: true,
                weight: 10,
                tooltip: 'The resource to be used to populate the data in the data table.',
            },
            {
                type: 'datagrid',
                input: true,
                label: 'Grid Components',
                key: 'fetch.components',
                tooltip: 'Select resource fields to display in data table.',
                weight: 15,
                reorder: true,
                logic: [
                    {
                        name: 'reset on resource change',
                        trigger: {
                            type: 'event',
                            event: 'change'
                        },
                        actions: [
                            {
                                name: 'reset value',
                                type: 'customAction',
                                customAction: "\n                  var changes =  _.get(result, '[0].changed', null);\n                  if (input.length && changes && changes.component && changes.component.key === 'fetch.resource') {\n                    instance.resetValue();\n                    instance.rebuild();\n                  }\n                "
                            }
                        ]
                    }
                ],
                addAnother: 'Add Component',
                initEmpty: true,
                validate: {
                    required: true
                },
                components: [
                    {
                        type: 'select',
                        input: true,
                        authenticate: true,
                        label: 'Component',
                        key: 'path',
                        skipMerge: true,
                        clearOnHide: true,
                        refreshOn: 'fetch.resource',
                        clearOnRefresh: true,
                        template: '<span>{{ item.label }}</span>',
                        valueProperty: 'key',
                        dataSrc: 'url',
                        lazyLoad: true,
                        onSetItems: "\n              const newItems = [];\n              utils.eachComponent(items.components, (component, path) => {\n                const compClass = Formio.Components?.components[component.type];\n                const nestedDataComp = Formio.Components?.components?.nesteddata;\n                const excludeFromOptions = !component.input\n                  || (compClass && nestedDataComp && compClass.prototype instanceof nestedDataComp && !_.includes(['address'], component.type))\n                  || _.includes(['button', 'form', 'datasource', 'sketchpad', 'reviewpage'], component.type);\n\n                if (!excludeFromOptions) {\n                  newItems.push({\n                    label: (component.label || component.key) + '(' + path + ')',\n                    key: path\n                  });\n                }\n\n                if (_.includes(['datamap', 'datagrid', 'editgrid', 'datatable', 'address', 'tagpad'], component.type)) {\n                  return true;\n                }\n              });\n              items = newItems;\n            ",
                        data: {
                            url: '/form/{{ data.fetch.resource }}',
                        },
                    },
                    {
                        label: 'Key',
                        key: 'key',
                        input: true,
                        type: 'textfield',
                        customClass: 'formio-builder-datatable-component-key',
                        allowCalculateOverride: true,
                        validate: {
                            pattern: '(\\w|\\w[\\w-.]*\\w)',
                            patternMessage: 'The key must only contain alphanumeric characters, underscores, dots and dashes and should not be ended by dash or dot.',
                        },
                        calculateValue: 'value = row.path;',
                    },
                ],
            }
        ], basicSourceSettings)
    },
];
